const startSaveBankAccount = (state) => {
  state.isSendFormCompanyBankAccount = true
  state.error = null
}

const changeEditedBankAccountState = (state, editedCompanyBankAccount) => {
  state.isSendFormCompanyBankAccount = false
  state.companyBankAccount = Object.assign({}, editedCompanyBankAccount)
  state.error = null
}

const finishSaveBankAccountSuccess = (state, companyBankAccount) => {
  const newCompanyBankAccount = Object.assign({}, companyBankAccount);
  state.isSendFormCompanyBankAccount = false
  state.companyBankAccount = newCompanyBankAccount
  state.error = null
}

const finishSaveBankAccountError = (state, error) => {
  state.isSendFormCompanyBankAccount = false
  state.error = error
}

const clearStateCompanyBankAccount = (state) => {
  state.companyBankAccount = {
    account_number: '',
    bank_id: 0,
    bank_name: '',
    currency: 'UAH',
    id: 0,
    is_visible: false,
    mfo: '',
    name: '',
    overdraft: 0,
  }
}

const fetchBankAccounts = (state) => {
  state.isLoading = true
  state.error = null
  state.companyBankAccounts = []
}

const fetchBankAccountSuccess = (state, companyBankAccounts) => {
  state.isLoading = false
  state.error = null
  state.companyBankAccounts = companyBankAccounts
}

const fetchBankAccountError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.companyBankAccounts = []
}

export default {
  startSaveBankAccount,
  finishSaveBankAccountSuccess,
  finishSaveBankAccountError,
  clearStateCompanyBankAccount,
  fetchBankAccountSuccess,
  fetchBankAccountError,
  fetchBankAccounts,
  changeEditedBankAccountState,
}
